import styles from "./Contracts.module.css";
import {
  TextField,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  Checkbox,
  FormGroup,
  FormControlLabel,
  FormLabel,
} from "@material-ui/core";
import { GET_USERS_COLLABORATOR_CONTRACT } from "../../Querys/querys";
import { useQuery } from "@apollo/client";
import { useCallback, useEffect, useState } from "react";
import { ErrorAlert } from "../../alerts/errorAlert";
import { server } from "../../global/server";
import Swal from "sweetalert2";
import axios from "axios";

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

export const Contract = (props: TabPanelProps) => {
  const [users, setUsers] = useState<any>([]);
  const [groupContract, setGroupContract] = useState<any>("");
  const [type, setType] = useState<any>("");
  const [tipoDocumentos, setTipoDocumentos] = useState<string[]>([]);
  const [userSelected, setUserSelected] = useState<any>("");
  const [userSelectedName, setUserSelectedName] = useState<any>("");
  const [userData, setUserData] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [filtrado, setFiltrado] = useState<any>([]);
  const [show, setShow] = useState<boolean>(false);
  const [disabledButton, setDisabledButton] = useState<boolean>(false);
  const [dateOfAdmission, setDateOfAdmission] = useState<any>("");
  const [dateContractDate, setDateContractDate] = useState<any>("");
  const [nominesPayroll, setNominesPayroll] = useState<any>("");
  const [hiringType, setHiringType] = useState<any>("");

  type Documento = {
    tipoDocumento: string;
    pdfUrl: string;
    thumbnailUrl: string;
  };
  const [urlDocumentos, setUrlDocumentos] = useState<Documento[]>([]);
  const [urlZip, setUrlZip] = useState<any>("");

  const docsToCreate = [
    "Contrato",
    "CartaAfiliacion",
    "CartaAceptacionPrestacionesSindicales",
    "ConvenioConfidencialidad",
    "Kardex",
  ];

  const allDocs = [...docsToCreate];

  const { data: resultUsers, startPolling, stopPolling } = useQuery(
    GET_USERS_COLLABORATOR_CONTRACT,
    {
      variables: { type: type ? type : "" },
    }
  );

  const resul = resultUsers?.GET_USERS_COLLABORATOR_CONTRACT;

  const getUserSelectedData = useCallback(() => {
    if (userSelected !== "" && users) {
      const data = users.filter(
        (user: any) => String(user.id) === userSelected
      );
      setUserData(data.length > 0 ? data : null);
    }
  }, [userSelected, users]);

  const filtrarCollaborator = (colaborador: string) => {
    let datosfiltrados = users.filter((lis: any) =>
      lis?.bussinesName
        ?.toUpperCase()
        .includes(colaborador.toString().toUpperCase())
    );

    if (colaborador === "") {
      datosfiltrados = users;
      setUserData(null);
      setShow(false);
      setUserSelectedName("");
      setUserSelected("");
      // 🔸 No borramos las fechas
      setFiltrado(datosfiltrados);
      setTipoDocumentos(allDocs);
    }

    setFiltrado(datosfiltrados);
    setUserSelectedName(colaborador);
  };

  useEffect(() => {
    if (userSelected !== "") {
      getUserSelectedData();
    }
  }, [userSelected, getUserSelectedData]);

  useEffect(() => {
    if (resul) {
      setUsers(resul);
      setFiltrado(resul);
    }
  }, [resul]);

  useEffect(() => {
    startPolling(10000);
    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling]);

  const clearDate = (changeType: any) => {
    if (changeType === "indeterminado") {
      setDateContractDate("");
    }
  };

  const collaboratorChoose = (user: any) => {
    setShow(false);
    setUserSelectedName(user?.bussinesName);
    setUserSelected(user?.id);
    setNominesPayroll(user?.nominesPayroll);
    setHiringType(user?.tittle);
    // 🔸 No borramos las fechas aquí

    setTipoDocumentos(
      allDocs.filter((doc) => {
        if (
          type === "renovacion" ||
          user?.nominesPayroll === "Nomina" ||
          user?.tittle === "outsource"
        ) {
          return doc === "Contrato" || doc === "ConvenioConfidencialidad";
        }
        return true;
      })
    );
  };

  const handleTipoDocumentoChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.name;
    setTipoDocumentos((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  const handleTypeContract = (e: any) => {
    setType(e);
    clearDate(e);

    setTipoDocumentos(
      allDocs.filter((doc) => {
        if (e === "renovacion" || nominesPayroll === "Nomina" || hiringType === "outsource") {
          return doc === "Contrato" || doc === "ConvenioConfidencialidad";
        }
        return true;
      })
    );
  };

  const formatearFecha = (fechaStr?: string | null): string | null => {
    if (!fechaStr || typeof fechaStr !== "string") return null;
    const [yearStr, monthStr, dayStr] = fechaStr.split("-");
    if (!yearStr || !monthStr || !dayStr) return null;
    const year = Number(yearStr);
    const month = Number(monthStr);
    const day = Number(dayStr);

    if (
      isNaN(year) ||
      isNaN(month) ||
      isNaN(day) ||
      month < 1 ||
      month > 12 ||
      day < 1 ||
      day > 31
    )
      return null;
    const diaFormateado = String(day).padStart(2, "0");
    const mesFormateado = String(month).padStart(2, "0");
    return `${diaFormateado}-${mesFormateado}-${year}`;
  };

  const handleCreateDocuments = async () => {
    if (!groupContract || groupContract === "") {
      ErrorAlert({ text: "Debes seleccionar un grupo de contrato." });
      return;
    }
    if (!type || type === "") {
      ErrorAlert({ text: "Debes seleccionar un tipo de contrato." });
      return;
    }
    if (!dateOfAdmission) {
      ErrorAlert({ text: "Debes ingresar la fecha de inicio del contrato." });
      return;
    }
    if ((type === "determinado" || type === "renovacion") && !dateContractDate) {
      ErrorAlert({ text: "Debes ingresar la fecha final del contrato." });
      return;
    }
    const d1 = new Date(dateOfAdmission).toDateString();
    const d2 = new Date(dateContractDate).toDateString();
    if (d1 === d2) {
      ErrorAlert({
        text: "La fecha final contrato no puede ser igual a la fecha de admisión.",
      });
      return;
    }
    if (!tipoDocumentos || tipoDocumentos.length === 0) {
      ErrorAlert({ text: "Debes seleccionar al menos un tipo de documento." });
      return;
    }
    if (!userSelected) {
      ErrorAlert({ text: "Debes selecccionar a un colaborador" });
      return;
    }
    const payload = {
      tipoDocumentos,
      groupContract,
      typeContract: type,
      initDate: formatearFecha(dateOfAdmission),
      endDate: formatearFecha(dateContractDate),
      idUser: userSelected,
    };
    setLoading(true);
    setDisabledButton(true);
    try {
      const urlContracts = `${server}/Contracts`;
      const res = await axios.post(urlContracts, payload);
      const documentsURL = res.data.documentos;
      setUrlZip(res.data.zipUrl);
      setUrlDocumentos(documentsURL);
      setLoading(false);
      setDisabledButton(false);
    } catch (error) {
      setLoading(false);
      setDisabledButton(false);
      ErrorAlert({ text: "No es posible generar los documentos" });
      return;
    }
  };

  const handleClearStates = () => {
    setGroupContract("");
    setType("");
    setTipoDocumentos(allDocs);
    setUserSelected("");
    setUserSelectedName("");
    setUserData(null);
    setFiltrado(users);
    setDateOfAdmission("");
    setDateContractDate("");
    setUrlDocumentos([]);
    setNominesPayroll("");
    setHiringType("");
  };

  const accentMap: Record<string, string> = {
    Afiliacion: "Afiliación",
    Aceptacion: "Aceptación",
  };

  const formatForDisplay = (text: string): string => {
    return text
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .split(" ")
      .map((word) => accentMap[word] || word)
      .join(" ");
  };

  const downLoadFiles = async () => {
    const link = document.createElement("a");
    link.href = urlZip;
    link.setAttribute("download", `zip${userSelected}.zip`);
    document.body.appendChild(link);
    link.click();
    link.remove();

    Swal.fire({
      icon: "success",
      title: "¡Listo!",
      text: "Los documentos fueron generados y descargados correctamente.",
      timer: 3000,
      showConfirmButton: false,
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.divContract}>
        <div className={styles.divGenerateContract}>
          {/* FORMULARIO */}
          <div className={styles.contenedorFieldset} style={{ width: "50%" }}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel style={{ backgroundColor: "#fff" }}>
                Grupo de contrato
              </InputLabel>
              <Select
                value={groupContract}
                onChange={(e) => setGroupContract(e.target.value)}
              >
                <MenuItem value="staff">Staff</MenuItem>
                <MenuItem value="consultores">Consultores</MenuItem>
                <MenuItem value="developers">Desarrolladores</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className={styles.contenedorFieldset} style={{ width: "50%" }}>
            <FormControl fullWidth size="small" variant="outlined">
              <InputLabel style={{ backgroundColor: "#fff" }}>
                Tipo Contrato
              </InputLabel>
              <Select
                value={type}
                onChange={(e) => handleTypeContract(e.target.value)}
              >
                <MenuItem value="determinado">Determinado</MenuItem>
                <MenuItem value="renovacion">Renovación</MenuItem>
                <MenuItem value="indeterminado">Indeterminado</MenuItem>
              </Select>
            </FormControl>
          </div>

          <div className={styles.contenedorFieldset} style={{ width: "50%" }}>
            <TextField
              label="Fecha inicial"
              type="date"
              value={dateOfAdmission}
              onChange={(e) => setDateOfAdmission(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
              size="small"
            />
          </div>

          <div className={styles.contenedorFieldset} style={{ width: "50%" }}>
            <TextField
              label="Fecha final"
              type="date"
              value={dateContractDate}
              onChange={(e) => setDateContractDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
              size="small"
              disabled={type === "indeterminado"}
            />
          </div>

          <div className={styles.contenedorFieldset} style={{ width: "50%" }}>
            <TextField
              fullWidth
              name="Colaborador"
              label="Colaborador"
              variant="outlined"
              size="small"
              inputProps={{ maxLength: 30 }}
              value={userSelectedName}
              onChange={(e) => filtrarCollaborator(e.target.value)}
              onClick={() => setShow(!show)}
            />
            {show && filtrado?.length > 0 && (
              <div className={styles.divCollaborator}>
                {filtrado?.map((user: any) => (
                  <p key={user.id} onClick={() => collaboratorChoose(user)}>
                    {user?.bussinesName}
                  </p>
                ))}
              </div>
            )}
          </div>

          <div className={styles.contenedorFieldset} style={{ width: "50%" }}>
            <FormControl component="fieldset">
              <FormLabel component="legend">Tipo de documentos</FormLabel>
              <FormGroup>
                {docsToCreate.map((doc) => (
                  <FormControlLabel
                    key={doc}
                    control={
                      <Checkbox
                        size="small"
                        style={{ color: "#FABB00" }}
                        checked={tipoDocumentos.includes(doc)}
                        onChange={handleTipoDocumentoChange}
                        name={doc}
                        disabled={
                          (type === "renovacion" ||
                            nominesPayroll === "Nomina" ||
                            hiringType === "outsource") &&
                          doc !== "Contrato" && doc !== "ConvenioConfidencialidad"
                        }
                      />
                    }
                    label={formatForDisplay(doc)}
                  />
                ))}
              </FormGroup>
            </FormControl>
          </div>

          {/* BOTONES */}
          <div
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            <div className="containerAddPrestacion">
              <button
                className="btnAddPrestacion"
                disabled={disabledButton}
                onClick={handleCreateDocuments}
              >
                <div className="infobtnAddRestriccion">
                  <div>
                    <span className="txtBtnAdd">
                      {" "}
                      Generar Documentos{" "}
                    </span>
                  </div>
                </div>
              </button>
            </div>
            <div className="containerCancelPreestacion">
              <button
                className="btnCancelPrestacion"
                disabled={disabledButton}
                onClick={handleClearStates}
              >
                <div className="iconoCancelPrestacion"></div>
                Cancelar
              </button>
            </div>
          </div>
        </div>

        {/* DOCUMENTOS */}
        <div className={styles.divGenerateContract}>
          {loading ? (
            <div className="c_contenedorPrincipal">
              <div className="contenedorLoadingPrincipal">
                <div className="loadingPrincipal"></div>
              </div>
            </div>
          ) : (
            <>
              {urlDocumentos.length > 0 && (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 1fr",
                    gap: "20px",
                  }}
                >
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 1fr)",
                      gap: "20px",
                    }}
                  >
                    {urlDocumentos.map((doc, idx) => (
                      <div key={idx} style={{ textAlign: "center" }}>
                        <a
                          href={doc.pdfUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={doc.thumbnailUrl}
                            alt={`Thumbnail ${doc.tipoDocumento}`}
                            style={{
                              width: "80%",
                              height: "auto",
                              cursor: "pointer",
                              borderRadius: 8,
                            }}
                          />
                        </a>
                        <p style={{ marginTop: 5 }}>
                          {formatForDisplay(doc.tipoDocumento)}
                        </p>
                      </div>
                    ))}
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <div className="containerAddPrestacion">
                      <button
                        className="btnAddPrestacion"
                        disabled={disabledButton}
                        onClick={downLoadFiles}
                      >
                        <div className="infobtnAddRestriccion">
                          <div>
                            <span className="txtBtnAdd">
                              {" "}
                              Descargar Documentos{" "}
                            </span>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
